import { InjectionToken } from '@angular/core';

/**
 * @description    Get the sufix for the date
 * @param dateObj  Date object
 */
export const getOrdinalFromDateObject = (dateObj: Date): string => {
    const date = dateObj.getDate();
    const REMAINING = 'th';
    let result;

    // The terrible teens
    if (date > 10 && date < 20) {
        result = date + REMAINING;
    } else {
        const num = date % 10;
        switch (num) {
            case 1:
                result = date + 'st';
                break;
            case 2:
                result = date + 'nd';
                break;
            case 3:
                result = date + 'rd';
                break;
            default:
                result = date + REMAINING;
        }
    }

    return result;
};

export type GetOrdinalFromDateObjectProvider = (dateObj: Date) => string;
export const GET_ORDINAL_FROM_DATE_OBJECT =
    new InjectionToken('GET_ORDINAL_FROM_DATE_OBJECT', {
        factory: () => getOrdinalFromDateObject
    });
